<template>
  <div
    class="modal modal--tight fade"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button
          type="button"
          class="modal__close btn btn--primary btn--sm btn--icon-only"
          data-dismiss="modal"
          :aria-label="i18n.closeModal"
        >
          <Icon name="times" extra-classes="icon--sm" />
          <span class="sr-only">{{ i18n.closeModal }}</span>
        </button>

        <div class="modal-body" data-target="modal.body">
          <div>
            <div v-if="title" class="font-size-lg md-font-size-xl color-text-dark font-weight-bold mb-0 pr-4">
              {{ title }}
            </div>

            <div v-if="text" data-controller="read-more">
              <div
                class="lheight-wide font-size-sm color-text-dark mt-2 overflow-hidden read-more"
                data-target="read-more.content"
                aria-expanded="false"
              >
                {{ text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/cart/components/Icon.vue';

export default {
  components: {
    Icon,
  },

  props: {
    id: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    text: {
      type: String,
    },
  },
};
</script>
